<div class="wrap">
  <h3>Gérer toutes mes actus</h3>

  <p *ngIf="myMenuFluxActu?.length < 1">Vous n'avez pas de flux d'actualité</p>

  <ng-container *ngIf="myMenuFluxActu?.length > 0">

    <p class="description">Ajouter ou retirer un flux d'actu dans le menu "Toutes mes actus" .</p>

    <ul>
      <mat-checkbox class="example-margin" [checked]="allComplete" [indeterminate]="someComplete()"
        (change)="setAll($event.checked); allVisibleOrNot()">
        {{label.name}}
      </mat-checkbox>
      <li *ngFor="let subtask of label.sublabels">
        <mat-checkbox [(ngModel)]="subtask.completed" [color]="color" (ngModelChange)="updateAllComplete()"
          (change)="oneElementVisibleOrNot(subtask)">
          {{subtask.name}}
        </mat-checkbox>
      </li>
    </ul>
  </ng-container>

  <div class="btn_action">
    <button class="back" (click)="cancel()">Retour</button>
    <button class="confirm" (click)="submitChange()">Confirmer</button>
  </div>
</div>